// API Configuration file for centralized URL management
export const apiConfig = {
  baseUrl: "https://app.meroprints.com/api/v1",
  // baseUrl: "http://192.168.1.80:8005/api/v1",
  imageUrl: "",
  sendEmailUrl: '/send-email/',
  changePasswordUrl: '/change-password/',
  profileUrl: '/profile/',
  verifyOtpUrl: "/verify-otp/",
  verifyOrder: "/order/",
  sendOtpUrl: "/send-otp/",
  registerUrl: "/register/",
  loginUrl: "/login/",
  logoutUrl: "/logout/",
  veryFiedToken: "/login-token/verify/",
  // uploadCsvSample: "/student/",
  // classdetails: "/class-info/",
  schooDetailsUrl: "/school/",
  classinfo: "/class-info/",
  employee: "/employee/",
  studentsDetail: "/student/",
  migratedstudentsDetail: "/migrated-student/",
  notificationDetail: "/notification/",
  assignedCardSample: "/choosen-card/",
  cardSample: "/card-samples/",
  hotDeals: "/hot-deals/",
  servicesCard: "/services/",
  servicesTypeCard: "/service-detail/",
  addressProvince: "/address/",
  veryfiedUser: "/verified-user/",
  choosenCardSample: "/choosen-card/",
  previewCard: "/preview-card/",
  classVerified: "/class-info/",
  countStudent: "/user-count/",
  promoteStudent: "/promote-student/",
  checkStudentEnrollment: "/check-student-enrollment/",
  getEnrollStudent:"/enroll-student-list/",
  secretKey:
    "pttiqag7iXnn5i-^he%um*hg_fv&z#+@q^_J@NcQfTjWnZr4u7x!A%D*G-(+sgy9l^$z7)",
    tokenKey: ""
};
